import { render, staticRenderFns } from "./ApproveAnonymizationDialog.vue?vue&type=template&id=74323721&"
import script from "./ApproveAnonymizationDialog.vue?vue&type=script&lang=js&"
export * from "./ApproveAnonymizationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports